import { useLocale } from 'next-intl'

import { TSearchRoom, useSearchFilterStore } from '@/entities/map'
import {
  MobileDiscountBadge,
  MobileOverview,
  MobilePriceDetail,
  RoomThumbnail,
  SuperHostBadge,
} from '@/entities/room'
import { Link } from '@/shared/i18n'
import { cn, getURLWithParams } from '@/shared/lib'

type Props = {
  room: TSearchRoom
}

export const MobileRoomItem = ({ room }: Props) => {
  const locale = useLocale()
  const isEnglish = locale === 'en'

  const startDate = useSearchFilterStore(state => state.filters.startDate)
  const endDate = useSearchFilterStore(state => state.filters.endDate)

  return (
    <Link
      className="flex grow cursor-pointer flex-col"
      href={getURLWithParams(`/guest/room/${room.rid}`, {
        startDate,
        endDate,
      })}
    >
      <div className="flex justify-between gap-4">
        <div>
          {room.isSuperHost && (
            <SuperHostBadge
              className={cn('mb-2')}
              width={isEnglish ? 93 : 52}
              height={18}
            />
          )}
          <MobileOverview
            province={room.province}
            town={room.town}
            propertyType={room.propertyType}
            roomName={room.roomName}
            roomCnt={room.roomCnt}
            bathroomCnt={room.bathroomCnt}
            cookroomCnt={room.cookroomCnt}
            sittingroomCnt={room.sittingroomCnt}
            usingFee={room.usingFee}
            mgmtFee={room.mgmtFee}
          />
          <MobilePriceDetail usingFee={room.usingFee} mgmtFee={room.mgmtFee} />
        </div>

        <RoomThumbnail
          src={room.picMain}
          alt={room.roomName}
          rounded
          size={100}
          ratio="1:1"
          unoptimized
        />
      </div>
      <MobileDiscountBadge
        percent={room.longtermDiscountPer}
        amount={room.earlyDiscountAmount}
        className="mt-2"
      />
    </Link>
  )
}
